"use strict";

var _toConsumableArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var Eth_1 = require("./Eth");

var Subscription = /*#__PURE__*/function () {
  function Subscription(query) {
    _classCallCheck(this, Subscription);

    this.query = query;
    this.log$ = new rxjs_1.Subject();
    this.root = null;
    this.subjectsMap = new Map(); //
  }

  _createClass(Subscription, [{
    key: "create",
    value: function create(type) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var result, params, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = null;
                params = [type, options];
                _context2.next = 4;
                return this.createSubscriptionId(params);

              case 4:
                id = _context2.sent;

                if (id) {
                  result = new rxjs_1.Subject();
                  result.id = id;
                  result.params = params;
                  this.query.currentProvider.notification$.pipe(operators_1.filter(function (notification) {
                    return notification && notification.subscription === result.id;
                  }), operators_1.map(function (notification) {
                    var result = null;
                    var raw = notification.result;

                    switch (type) {
                      case Subscription.Types.NewHeads:
                        result = Eth_1.Eth.prepareBlockResult(raw);
                        break;

                      case Subscription.Types.Logs:
                        result = Eth_1.Eth.prepareLogResult(raw);
                        break;

                      case Subscription.Types.NewPendingTransactions:
                        result = raw;
                        break;
                    }

                    return result;
                  }), operators_1.filter(function (result) {
                    return !!result;
                  })).subscribe(result);

                  result.unsubscribe = function () {
                    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              result.complete();
                              this.subjectsMap.delete(id);
                              _context.next = 4;
                              return this.destroySubscriptionId(result.id);

                            case 4:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, this);
                    }));
                  };

                  if (!this.root) {
                    this.root = this.query.currentProvider.connected$.pipe(operators_1.filter(function (value) {
                      return !!value;
                    })).subscribe(function () {
                      return _this.resubscribeAll(false).catch(function (err) {
                        _this.log$.next({
                          type: Subscription.LogTypes.Error,
                          data: err
                        });
                      });
                    });
                  }

                  this.subjectsMap.set(result.id, result);
                }

                return _context2.abrupt("return", result);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "resubscribeAll",
    value: function resubscribeAll() {
      var unsubscribe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var iterator, _iterator, _step, subject;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                iterator = this.subjectsMap.values();
                _iterator = _createForOfIteratorHelper(iterator);
                _context3.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 14;
                  break;
                }

                subject = _step.value;

                if (!unsubscribe) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 9;
                return this.destroySubscriptionId(subject.id);

              case 9:
                _context3.next = 11;
                return this.createSubscriptionId(subject.params);

              case 11:
                subject.id = _context3.sent;

              case 12:
                _context3.next = 4;
                break;

              case 14:
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](2);

                _iterator.e(_context3.t0);

              case 19:
                _context3.prev = 19;

                _iterator.f();

                return _context3.finish(19);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 16, 19, 22]]);
      }));
    }
  }, {
    key: "unsubscribeAll",
    value: function unsubscribeAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var iterator, _iterator2, _step2, subject;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                iterator = this.subjectsMap.values();
                _iterator2 = _createForOfIteratorHelper(iterator);
                _context4.prev = 2;

                _iterator2.s();

              case 4:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 10;
                  break;
                }

                subject = _step2.value;
                _context4.next = 8;
                return subject.unsubscribe();

              case 8:
                _context4.next = 4;
                break;

              case 10:
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](2);

                _iterator2.e(_context4.t0);

              case 15:
                _context4.prev = 15;

                _iterator2.f();

                return _context4.finish(15);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 12, 15, 18]]);
      }));
    }
  }, {
    key: "createSubscriptionId",
    value: function createSubscriptionId(params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$query;

        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                result = (_this$query = this.query).send.apply(_this$query, [Eth_1.Eth.Methods.Subscribe].concat(_toConsumableArray(params.filter(function (value) {
                  return !!value;
                }))));
                this.log$.next({
                  type: Subscription.LogTypes.Subscribed,
                  data: result
                });
                return _context5.abrupt("return", result);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "destroySubscriptionId",
    value: function destroySubscriptionId(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.query.send(Eth_1.Eth.Methods.Unsubscribe, id);

              case 2:
                this.log$.next({
                  type: Subscription.LogTypes.Unsubscribed,
                  data: id
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return Subscription;
}();

exports.Subscription = Subscription;

(function (Subscription) {
  var Types;

  (function (Types) {
    Types["NewHeads"] = "newHeads";
    Types["Logs"] = "logs";
    Types["NewPendingTransactions"] = "newPendingTransactions";
  })(Types = Subscription.Types || (Subscription.Types = {}));

  var LogTypes;

  (function (LogTypes) {
    LogTypes["Error"] = "Error";
    LogTypes["Subscribed"] = "Subscribed";
    LogTypes["Unsubscribed"] = "Unsubscribed";
  })(LogTypes = Subscription.LogTypes || (Subscription.LogTypes = {}));
})(Subscription = exports.Subscription || (exports.Subscription = {}));